export const SCROLLBAR_WIDTH = 7;

export function subScrollbarWidth(value: string): string;
export function subScrollbarWidth(value: number): number;
export function subScrollbarWidth(value: string | number): string | number {
  return typeof value === 'number'
    ? value - 7
    : `calc(${value} - ${SCROLLBAR_WIDTH}px)`;
}
